"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

var _objectSpread2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/objectSpread2.js"));

var _index = _interopRequireDefault(require("@/components/ReportNav/index.vue"));

var _vuex = require("vuex");

var _help = _interopRequireDefault(require("@/config/help.json"));

var _LineChart = _interopRequireDefault(require("@/components/Chart/LineChart.vue"));

var _common = require("@/api/common");

var _report = require("@/api/report");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'ReportAutoTest',
  components: {
    ReportNav: _index.default,
    LineChart: _LineChart.default
  },
  data: function data() {
    return {
      help: _help.default,
      projectId: '',
      reportId: '',
      activeNames: [],
      pageKey: '',
      pageConfig: {
        summary: [],
        chartInfo: []
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['reportDevice'])),
  created: function created() {
    var _this = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var informRes, fileRes, i;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log(_this.$route);
              _this.projectId = _this.$route.params.projectId;
              _this.reportId = _this.$route.params.reportId;

              if (!_this.$route.meta.pageKey) {
                _context.next = 13;
                break;
              }

              _this.pageKey = _this.$route.meta.pageKey;
              _context.next = 7;
              return (0, _report.informJSONInfo)({
                inform_id: _this.reportId,
                key: _this.pageKey
              });

            case 7:
              informRes = _context.sent;
              _context.next = 10;
              return (0, _common.getFile)(informRes.data.data);

            case 10:
              fileRes = _context.sent;
              _this.pageConfig = fileRes.data;
              console.log('pageConfig', _this.pageConfig);

            case 13:
              console.log('template');

              for (i = 0; i < _this.pageConfig.chartInfo.length; i++) {
                _this.activeNames.push(i + '');
              }

              console.log('reportDevice', _this.reportDevice);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {},
  methods: {
    handleChange: function handleChange(value) {
      console.log(value);
    }
  }
};
exports.default = _default;